module.exports = __webpack_public_path__ + "static/media/studentlife-sports--resized.6461743d.jpg";